// components
import NotiLogItemMobile from './notiLogItem_mobile';

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";

// css
import './notiLog_mobile.css';

// services
import { authGuest, setDelToken, setToken, getUser, isUser } from "../../../service/authService";
import { getUserStatPage } from '../../../service/monitor/allStatusService';
import { getNotificationList } from '../../../service/pushService';

function NotiLogMobile({conn, setUpdateLoginStatus, loginStatus}) {

  const userInfo = getUser();
  const locationState = useLocation().state;

  const [loading, setLoading] = useState(false);
  
  const [search, setSearch] = useState({
    userId: userInfo.userTypeCode !== 2006 ? userInfo.userId : userInfo.userId.split("_")[0],
    rgnCode: userInfo.rgnCode,
    dongCode: userInfo.dongCode,
    userTypeCode: userInfo.userTypeCode,
    sentYn: "Y",
    history: "Y"
  })

  const [dataSource, setDataSource] = useState({
    all: [],
  })

  const getData = () => {
    getNotificationList(conn, search)
    .then((response) => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.all = response;
        return item;
      })
      console.log("response = ", response);
    })
    .catch((err) => {
      console.log("err = ", err);
    })
  }

  useEffect(() => {
    getData();
  },[])

  return (
    <>
      <div className="pageContent_m">
        {dataSource.all.length ? (
          dataSource.all.map(item => {
            return <NotiLogItemMobile conn={conn} item={item} />;
          })
        ) : (
          <div></div>
        )}
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#cc76c9" />
        </p>
      )}
    </>
  );
}

export default NotiLogMobile;
